import request from '../../utils/request';

export default async id => request('/ala-agreements').then(data => (data && data.length ? data.find(item => item.id === parseInt(id, 10)) : {}));
